import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Ciclo simétrico de abrir/fechar, inclusive no StrictMode do React 19.
// Não depende do contador global de instâncias do react-modal.
export default function PecuariaDialog({ title, darkMode, busy, onClose, children }) {
  const dialog = useRef(null);
  const state = useRef({ busy, onClose });
  state.current = { busy, onClose };
  useEffect(() => {
    const root = document.getElementById('root');
    const previousFocus = document.activeElement;
    const previousAria = root?.getAttribute('aria-hidden');
    const previousInert = root?.inert;
    const hadBodyClass = document.body.classList.contains('pec-modal-open');
    document.body.classList.add('pec-modal-open');
    if (root) { root.setAttribute('aria-hidden', 'true'); root.inert = true; }
    dialog.current?.focus();
    const focusables = () => Array.from(dialog.current?.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]') || []);
    const keydown = event => {
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopPropagation();
        if (!state.current.busy) state.current.onClose();
      }
      if (event.key !== 'Tab') return;
      const elements = focusables(); const first = elements[0]; const last = elements[elements.length - 1];
      if (!elements.length) { event.preventDefault(); dialog.current?.focus(); }
      else if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', keydown, true);
    return () => {
      document.removeEventListener('keydown', keydown, true);
      if (!hadBodyClass) document.body.classList.remove('pec-modal-open');
      if (root) {
        if (previousAria == null) root.removeAttribute('aria-hidden'); else root.setAttribute('aria-hidden', previousAria);
        root.inert = previousInert;
      }
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, []);
  return createPortal(<div className="pec-overlay" onMouseDown={event => {
    if (event.target === event.currentTarget && !state.current.busy) state.current.onClose();
  }}><section ref={dialog} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} className={`pec-modal ${darkMode ? 'pec-dark' : ''}`}>{children}</section></div>, document.body);
}
